import React from "react";
// @ts-ignore
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import docsSpec from "./docs.json";
import { Card } from "@mui/material";

const OpenapiDocs: React.FC = () => {
  const swaggerSpec = {
    ...docsSpec,
    servers: [
      {
        url: process.env.REACT_APP_OPENAPI_URL || "https://localhost",
      },
    ],
  };

  return (
    <Card
      sx={{
        maxWidth: "1000px",
        margin: "0 auto",
      }}
    >
      <SwaggerUI spec={swaggerSpec} />
    </Card>
  );
};

export default OpenapiDocs;
